(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementTicker {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-ticker-track]');
      this.group = root.querySelector('[data-ticker-group]');
      if (!this.track || !this.group) return;

      // Pixels travelled per second. Kept constant so adding copy makes the
      // loop longer rather than making the text move faster.
      this.speed = parseFloat(root.dataset.speed) || 60;

      this.baseItems = Array.from(this.group.children).map((n) => n.cloneNode(true));
      if (this.baseItems.length === 0) return;

      this.build();

      this.onResize = this.debounce(() => this.build(), 150);
      window.addEventListener('resize', this.onResize);
    }

    debounce(fn, wait) {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }

    build() {
      const containerWidth = this.root.offsetWidth;
      if (!containerWidth) return;

      // Reset to a single copy of the original items before re-measuring.
      this.track.innerHTML = '';
      this.group.innerHTML = '';
      this.baseItems.forEach((n) => this.group.appendChild(n.cloneNode(true)));
      this.track.appendChild(this.group);

      // Repeat the items until one group is wider than the bar. Without this
      // a short message leaves a gap the width of the viewport every loop.
      let guard = 0;
      while (this.group.offsetWidth < containerWidth && guard < 50) {
        this.baseItems.forEach((n) => this.group.appendChild(n.cloneNode(true)));
        guard += 1;
      }

      const groupWidth = this.group.offsetWidth;
      if (!groupWidth) return;

      // A second identical group means translating -50% lands exactly where
      // the first group started, so the seam is invisible.
      const clone = this.group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);

      this.root.style.setProperty('--ticker-duration', groupWidth / this.speed + 's');
      this.root.setAttribute('data-ticker-ready', '');
    }
  }

  function initTickers(scope) {
    (scope || document).querySelectorAll('[data-ticker]').forEach((root) => {
      if (root.dataset.tickerInit === 'true') return;
      root.dataset.tickerInit = 'true';
      new AnnouncementTicker(root);
    });
  }

  initTickers();

  document.addEventListener('shopify:section:load', (event) => {
    initTickers(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Submit the sort form as soon as a new option is chosen. The form still
  // works without this, via the <noscript> submit button.
  function initCollectionSort(scope) {
    (scope || document).querySelectorAll('[data-sort-form]').forEach((form) => {
      if (form.dataset.sortReady === 'true') return;
      form.dataset.sortReady = 'true';

      const select = form.querySelector('[data-sort-select]');
      if (!select) return;

      select.addEventListener('change', () => {
        form.submit();
      });
    });
  }

  initCollectionSort();

  document.addEventListener('shopify:section:load', (event) => {
    initCollectionSort(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductForm {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.product__form');
      this.variantInput = root.querySelector('[data-variant-id]');
      this.priceTarget = root.querySelector('[data-product-price]');
      this.addButton = root.querySelector('[data-add-to-cart]');
      this.addButtonText = root.querySelector('[data-add-to-cart-text]');

      const dataEl = root.querySelector('[data-product-variants]');
      this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];

      this.moneyFormat = null;
      this.bindOptions();
      this.bindThumbs();
    }

    bindOptions() {
      this.root.querySelectorAll('[data-option-value]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });
    }

    bindThumbs() {
      const main = this.root.querySelector('#product-main-image');
      const thumbs = this.root.querySelectorAll('[data-product-thumb]');
      if (!main || thumbs.length === 0) return;

      thumbs.forEach((thumb, index) => {
        if (index === 0) thumb.setAttribute('aria-current', 'true');

        thumb.addEventListener('click', () => {
          main.src = thumb.dataset.fullSrc;
          main.srcset = '';
          main.alt = thumb.dataset.fullAlt || '';
          thumbs.forEach((other) => other.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current', 'true');
        });
      });
    }

    selectedOptions() {
      return Array.from(this.root.querySelectorAll('[data-option-value]:checked')).map(
        (input) => input.value
      );
    }

    onOptionChange() {
      const selected = this.selectedOptions();
      const match = this.variants.find((variant) =>
        variant.options.every((value, index) => value === selected[index])
      );

      this.updateAvailability(selected);

      if (!match) {
        this.setUnavailable();
        return;
      }

      if (this.variantInput) this.variantInput.value = match.id;
      this.updatePrice(match);
      this.updateButton(match);
      this.updateUrl(match);
    }

    // Strike through option values that cannot combine with the current choices.
    updateAvailability(selected) {
      this.root.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const index = parseInt(fieldset.dataset.optionIndex, 10);

        fieldset.querySelectorAll('[data-option-value]').forEach((input) => {
          const candidate = selected.slice();
          candidate[index] = input.value;

          const reachable = this.variants.some(
            (variant) =>
              variant.available &&
              variant.options.every((value, i) => i === index || value === candidate[i])
          );

          const label = fieldset.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('product__swatch--unavailable', !reachable);
        });
      });
    }

    updatePrice(variant) {
      if (!this.priceTarget) return;
      const formatted = this.formatMoney(variant.price);
      let markup = '<span class="price"><span>' + formatted + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        markup +=
          '<s class="price__compare">' + this.formatMoney(variant.compare_at_price) + '</s>';
      }
      markup += '</span>';
      this.priceTarget.innerHTML = markup;
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: window.Shopify.currency.active,
          }).format(cents / 100);
        } catch (error) {
          return '$' + amount;
        }
      }
      return '$' + amount;
    }

    updateButton(variant) {
      if (!this.addButton) return;
      this.addButton.disabled = !variant.available;
      if (this.addButtonText) {
        this.addButtonText.textContent = variant.available
          ? this.addButton.dataset.labelAdd || this.addButtonText.textContent
          : this.addButton.dataset.labelSoldOut || this.addButtonText.textContent;
      }
    }

    setUnavailable() {
      if (this.addButton) this.addButton.disabled = true;
    }

    updateUrl(variant) {
      if (!window.history || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function initProductForms(scope) {
    (scope || document).querySelectorAll('.product').forEach((root) => {
      if (!root.querySelector('.product__form')) return;
      if (root.dataset.productReady === 'true') return;
      root.dataset.productReady = 'true';
      new ProductForm(root);
    });
  }

  initProductForms();

  document.addEventListener('shopify:section:load', (event) => {
    initProductForms(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  function initSlideshows(scope) {
    (scope || document).querySelectorAll('[data-slideshow]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-slides-track]');
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-slides-dot]'));
      if (!track || slides.length < 2) return;
      let index = 0;
      const goTo = (i) => {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      };
      const sync = () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && i >= 0 && i < slides.length) index = i;
        dots.forEach((d, j) => d.classList.toggle('is-active', j === index));
      };
      track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
      root.querySelector('[data-slides-prev]')?.addEventListener('click', () => goTo(index - 1));
      root.querySelector('[data-slides-next]')?.addEventListener('click', () => goTo(index + 1));
      dots.forEach((d) => d.addEventListener('click', () => goTo(Number(d.dataset.slidesDot))));
      if (root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const every = Math.max(3, Number(root.dataset.interval) || 6) * 1000;
        let timer = null;
        const start = () => { stop(); timer = window.setInterval(() => goTo(index + 1), every); };
        const stop = () => { if (timer) window.clearInterval(timer); timer = null; };
        root.addEventListener('pointerenter', stop);
        root.addEventListener('pointerleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
        document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
        start();
      }
    });
  }
  initSlideshows();
  document.addEventListener('shopify:section:load', (e) => initSlideshows(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-tutorials"] && !Shopify.designMode) return;
  try {
    
  // Swap the poster for the real embed only when someone asks to watch, so a
  // page with three tutorials does not load three video players up front.
  function initVideoFacades(scope) {
    (scope || document).querySelectorAll('[data-video-facade]').forEach((facade) => {
      if (facade.dataset.facadeReady === 'true') return;
      facade.dataset.facadeReady = 'true';

      const button = facade.querySelector('.video-card__play');
      if (!button) return;

      button.addEventListener('click', () => {
        const src = facade.dataset.embed;
        if (!src) return;

        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = button.getAttribute('aria-label') || 'Video';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';

        facade.replaceWith(iframe);
      });
    });
  }

  initVideoFacades();

  document.addEventListener('shopify:section:load', (event) => {
    initVideoFacades(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
